import { render } from "./QueOption4.vue?vue&type=template&id=768e4936"
import script from "./QueOption4.vue?vue&type=script&lang=js"
export * from "./QueOption4.vue?vue&type=script&lang=js"

import "./QueOption4.vue?vue&type=style&index=0&id=768e4936&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__